module.exports = __webpack_public_path__ + "static/media/icon-character__lech-walesa.77e61579.svg";